import { Routes } from '@angular/router';
import { ErrorSubmittingAppComponent } from '../../routes/+error-submitting-app';
import { GetStartedComponent } from '../../routes/+get-started';
import { AccountTypeComponent } from '../../routes/+account-type';
import { EmploymentInfoComponent } from '../../routes/+employment-info';
import { PersonalInfoComponent } from '../../routes/+personal-info';
import { RejectedAppComponent } from '../../routes/+rejected-app';
import { SSNComponent } from '../../routes/+ssn';
import { CipComponent } from '../../routes/+cip';
import { PersonalInfoACMComponent } from '../../routes/+personal-info-acm';
import { PersonalAddressComponent } from '../../routes/+personal-address';
import { PersonalContactComponent } from '../../routes/+personal-contact';
import { PersonalInfoAuthComponent } from '../../routes/+personal-info-auth';
import { FinancialInfoComponent } from '../../routes/+financial-info';
import { InvestmentObjectiveComponent } from '../../routes/+investment-objective';
import { InvestmentPreferencesComponent } from '../../routes/+investment-preferences';
import { TrustedContactComponent } from '../../routes/+trusted-contact';
import { SubmitApplicationComponent } from '../../routes/+submit-application';
import { PendingAppComponent } from '../../routes/+pending-app';
import { PendingAppCipComponent } from '../../routes/+pending-app-cip';
import { SubmitApplicationReviewComponent } from '../../routes/+submit-application-review';
import { FundAccountComponent } from '../../routes/+fund-account';
import { FundAbaRoutingComponent } from '../../routes/+fund-aba-routing';
import { FundingChoicesComponent } from '../../routes/+funding-choices';
import { FundingChoicesStreamlineComponent } from '../../routes/+funding-choices-streamline';
import { CredentialsComponent } from '../../routes/+credentials';
import { SuccessComponent } from '../../routes/+success';
import { DepositFundsComponent } from '../../routes/+deposit-funds';
import { ReviewDepositFundsComponent } from '../../routes/+review-deposit-funds';
import { DepositFundsReceiptComponent } from '../../routes/+deposit-funds-receipt';
import { AchProfileComponent } from '../../routes/+ach-profile';
import { AchProfileFailedComponent } from '../../routes/+ach-profile-failed';
import { PaperAccountComponent } from '../../routes/+paper-account';
import { FinishPaperAccountComponent } from '../../routes/+finish-paper-account';
import { FundByInvestComponent } from '../../routes/+fund-by-invest-account';
import { FundByWireComponent } from '../../routes/+fund-by-wire';
import { FundByBrokerComponent } from '../../routes/+fund-by-broker';
import { FundByBrokerChooseFirmComponent } from '../../routes/+fund-by-broker-choose-firm';
import { FundByBrokerAccountComponent } from '../../routes/+fund-by-broker-account';
import { FundByBrokerInfoComponent } from '../../routes/+fund-by-broker-info';
import { FundByBrokerManualComponent } from '../../routes/+fund-by-broker-manual';
import { FundByBrokerReviewComponent } from '../../routes/+fund-by-broker-review';
import { FundByBrokerReceiptComponent } from '../../routes/+fund-by-broker-receipt';
import { FundByCheckComponent } from '../../routes/+fund-by-check';
import { TimeOutComponent } from '../../routes/+time-out';
import { ExploreOtherOptionsComponent } from '../../routes/+explore-other-options';

import { WelcomeInvestorComponent } from '../../routes/+welcome-investor';
import { JointPersonalInfoComponent } from '../../routes/+joint-personal-info';
import { JointFinancialInfoComponent } from '../../routes/+joint-financial-info';
import { CustodialMinorInfoComponent } from '../../routes/+custodial-minor-info';
import { EditBeneficiaryInfoComponent } from '../../routes/+edit-beneficiary-info';
import { PrimaryBeneficiaryInfoComponent } from '../../routes/+primary-beneficiary-info';
import { WaysToFundComponent } from '../../routes/+ways-to-fund';
import { ManualComponent } from '../../routes/+manual';
import { ModalComponent } from '../../routes/+modal';

import { CashAllocationComponent } from '../../routes/+cash-allocation';
import { GoalComponent } from '../../routes/+goal';
import { TimeHorizonComponent } from '../../routes/+time-horizon';
import { FinancialPictureComponent } from '../../routes/+financial-picture';
import { RiskToleranceComponent } from '../../routes/+risk-tolerance';
import { StrategyTypeComponent } from '../../routes/+strategy-type';
import { RecommendationComponent } from '../../routes/+recommendation';
import { RetirementComponent } from '../../routes/+retirement';
import { DocumentUploaderComponent } from '../../routes/+document-uploader';
import { WelcomeBackComponent } from '../../routes/+welcome-back';

import { DataResolver } from '../../resolvers/data.resolver';
import { ReviewResolver } from '../../resolvers/review.resolver';
import { DepositAccountsResolver } from '../../resolvers/depositAccounts.resolver';

import { DTMGuard } from '../../guards/dtm.guard';
import { HandshakeCanActivate } from '../../guards/handshake.guard';
import { SubmitAcatsCanActivate } from '../../guards/submitAcats.guard';
import { GetKBACanActivate } from '../../guards/getKBA.guard';
import { MpQuestionnaireCanActivate } from '../../guards/mpQuestionnaire.guard';
import { DocumentConfirmationReceivedComponent } from '../../routes/+document-confirmation-received';
import { DocumentCheckYourInboxComponent } from '../../routes/+document-check-your-inbox';
import { OccupationListResolver } from '../../resolvers/occupationList.resolver';
import { IncomeListResolver } from '../../resolvers/incomeList.resolver';

export const ROUTES: Routes = [
  {
    path: 'modal',
    component: ModalComponent,
    outlet: 'aux',
  },
  {
    path: 'show',
    component: ModalComponent,
    outlet: 'timeout',
  },
  {
    path: '',
    canActivate: [HandshakeCanActivate],
    canActivateChild: [DTMGuard],
    children: [
      {
        path: '',
        component: GetStartedComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'select-account-type',
        component: AccountTypeComponent,
        resolve: {
          formData: DataResolver,
          occupationList: OccupationListResolver,
          incomeList: IncomeListResolver,
        },
      },
      {
        path: 'welcome-investor',
        component: WelcomeInvestorComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'paper-account',
        component: PaperAccountComponent,
      },
      {
        path: 'finish-paper-account',
        component: FinishPaperAccountComponent,
      },
      {
        path: 'fund-by-invest-account',
        component: FundByInvestComponent,
      },
      {
        path: 'fund-by-wire',
        component: FundByWireComponent,
      },
      {
        path: 'fund-by-check',
        component: FundByCheckComponent,
      },
      {
        path: 'fund-by-broker',
        component: FundByBrokerComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'fund-by-broker-choose-firm',
        component: FundByBrokerChooseFirmComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'fund-by-broker-account',
        component: FundByBrokerAccountComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'fund-by-broker-info',
        component: FundByBrokerInfoComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'fund-by-broker-manual',
        component: FundByBrokerManualComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'fund-by-broker-review',
        component: FundByBrokerReviewComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'fund-by-broker-receipt',
        canActivate: [SubmitAcatsCanActivate],
        component: FundByBrokerReceiptComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'personal-info',
        component: PersonalInfoComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'ssn',
        component: SSNComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'personal-info-acm',
        component: PersonalInfoACMComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'personal-address',
        component: PersonalAddressComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'personal-contact',
        component: PersonalContactComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'personal-info-auth',
        component: PersonalInfoAuthComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'cip',
        canActivate: [GetKBACanActivate],
        component: CipComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'employment-info',
        component: EmploymentInfoComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'financial-info',
        component: FinancialInfoComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'investment-objective',
        component: InvestmentObjectiveComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'investment-preferences',
        component: InvestmentPreferencesComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'trusted-contact',
        component: TrustedContactComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'joint-financial-info',
        component: JointFinancialInfoComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'joint-info',
        component: JointPersonalInfoComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'custodial-minor-info',
        component: CustodialMinorInfoComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'primary-beneficiary-info',
        component: PrimaryBeneficiaryInfoComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'edit-beneficiary-info',
        component: EditBeneficiaryInfoComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'submit-application',
        component: SubmitApplicationComponent,
        resolve: {
          formData: DataResolver,
          depositAccounts: DepositAccountsResolver,
        },
      },
      {
        path: 'submit-application-review',
        component: SubmitApplicationReviewComponent,
        resolve: {
          reviewObj: ReviewResolver, // Special
        },
      },
      {
        path: 'pending-app',
        component: PendingAppComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'pending-app-cip',
        component: PendingAppCipComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'rejected-app',
        component: RejectedAppComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'error-submitting-app',
        component: ErrorSubmittingAppComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'funding-choices',
        component: FundingChoicesComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'funding-choices-streamline',
        component: FundingChoicesStreamlineComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'fund-aba-routing',
        component: FundAbaRoutingComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'fund-account',
        component: FundAccountComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'ways-to-fund',
        component: WaysToFundComponent,
      },
      {
        path: 'credentials',
        component: CredentialsComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'success',
        component: SuccessComponent,
      },
      {
        path: 'manual',
        component: ManualComponent,
      },
      {
        path: 'deposit-funds',
        component: DepositFundsComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'deposit-funds-ira',
        component: DepositFundsComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'review-deposit-funds',
        component: ReviewDepositFundsComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'review-deposit-funds-ira',
        component: ReviewDepositFundsComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'deposit-funds-receipt',
        component: DepositFundsReceiptComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'verify-ach-profile-passed',
        component: AchProfileComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'verify-ach-profile-failed',
        component: AchProfileFailedComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'cash-allocation',
        canActivate: [MpQuestionnaireCanActivate],
        component: CashAllocationComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'goal',
        canActivate: [MpQuestionnaireCanActivate],
        component: GoalComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'time-horizon',
        canActivate: [MpQuestionnaireCanActivate],
        component: TimeHorizonComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'financial-picture',
        canActivate: [MpQuestionnaireCanActivate],
        component: FinancialPictureComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'risk-tolerance',
        canActivate: [MpQuestionnaireCanActivate],
        component: RiskToleranceComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'strategy-type',
        canActivate: [MpQuestionnaireCanActivate],
        component: StrategyTypeComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'recommendation',
        canActivate: [MpQuestionnaireCanActivate],
        component: RecommendationComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'retirement',
        canActivate: [MpQuestionnaireCanActivate],
        component: RetirementComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'explore-other-options',
        canActivate: [MpQuestionnaireCanActivate],
        component: ExploreOtherOptionsComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'verify-ach-profile-manual',
        component: AchProfileFailedComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'document-uploader',
        component: DocumentUploaderComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'document-confirmation-received',
        component: DocumentConfirmationReceivedComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'welcome-back',
        component: WelcomeBackComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'document-check-your-inbox',
        component: DocumentCheckYourInboxComponent,
        resolve: {
          formData: DataResolver,
        },
      },
      {
        path: 'timed-out',
        component: TimeOutComponent,
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];
